import { FormatAmount } from '@multiversx/sdk-dapp/UI';
import { useGetNetworkConfig } from '@multiversx/sdk-dapp/hooks';
import { ellipsisString } from 'src/helpers/functions';
import { breakpoints, useBreakpoints } from 'src/hooks/useBreakpoints';
import GlobalActions from './components/GlobalActions';
import { displayedCurrencyCode, tokenDecimal } from 'src/config';

import { useState } from 'react';

export default function AccountBalancePanel({ account, totalStakeAmounts, tokenBalance = 0 }) {
    const isMediumScreen = useBreakpoints(breakpoints.md);
    const { network } = useGetNetworkConfig();

    const [copied, setCopied] = useState(false);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
          .then(() => {
              console.log('Text copied successfully');
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
          })
          .catch(err => console.error('Failed to copy text: ', err));
    };


    return (
        <>
            <div className="panel">
                <div className='top'>
                    <div className='left'>
                        <strong className="title">Welcome to TADA Staking Dashboard!</strong>
                        <span className="subTitle">Connected account details</span>
                    </div>
                    <div className='right'>
                        <span>Audited by</span>
                        <img style={{height: '30px'}} src="assets/images/certification.png" alt="Certification companies" />
                    </div>
                </div>
                
                <div className='row'>
                    <div style={{flex: '1 1', display: 'flex', flexDirection: 'column'}}>
                        <div className="subPanel accountInfo">
                            <div className='informations'>
                                {account.username && 
                                    <div>
                                        <i>Herotag</i>
                                        <span>{account.username || 'N/A'}</span>
                                    </div>
                                }
                                <div>
                                    <i>Address</i>
                                    <span className='address'>
                                        {isMediumScreen ? ellipsisString(account.address, 15) : account.address}
                                        <button className='copy' onClick={() => copyToClipboard(account.address)}>
                                            <img src={copied ? "assets/icons/checked.svg" : "assets/icons/copy.svg"} alt="Copy icon" />
                                        </button>
                                    </span>
                                </div>
                            </div>
                            
                            <i>Balance</i>
                            <div className="balances">
                                <span>
                                    <FormatAmount value={account.balance} egldLabel={network.egldLabel} showLabel={false} />
                                    <i> EGLD</i>
                                </span>
                                <i>|</i>
                                <span>
                                    <FormatAmount value={tokenBalance} decimals={tokenDecimal} showLabel={false} />
                                    <i> {displayedCurrencyCode}</i>
                                </span>
                            </div>
                        </div>

                        <GlobalActions account={account} totalStakeAmounts={totalStakeAmounts} />
                    </div>
                </div>
            </div>
        </>
    );
}
